@if (html(); as html) {
  <!-- Trusted app-built markup only; callers must escapeHtml() user data. -->
  <span [innerHTML]="html"></span>
}
